import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const SystemStatusContext = createContext(null);

export const useSystemStatus = () => {
  const context = useContext(SystemStatusContext);
  if (!context) {
    throw new Error('useSystemStatus must be used within a SystemStatusProvider');
  }
  return context;
};

export const SystemStatusProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = useCallback((message) => {
    setMessages(prevMessages => {
      const existingIndex = prevMessages.findIndex(m => m.id === message.id);
      if (existingIndex > -1) {
        const newMessages = [...prevMessages];
        newMessages[existingIndex] = { ...newMessages[existingIndex], ...message };
        return newMessages;
      }
      return [...prevMessages, message];
    });
  }, []);

  const removeMessage = useCallback((id) => {
    setMessages(prevMessages => prevMessages.filter(m => m.id !== id));
  }, []);

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);

  const contextValue = useMemo(() => ({
    messages,
    addMessage,
    removeMessage,
    clearMessages,
  }), [messages, addMessage, removeMessage, clearMessages]);

  return (
    <SystemStatusContext.Provider value={contextValue}>
      {children}
    </SystemStatusContext.Provider>
  );
};

SystemStatusProvider.propTypes = {
  children: PropTypes.node.isRequired,
};